import posthog from "posthog-js";
import { OPEN_HOUSE_VIEW_EVENT } from "./directory-reporting-events";

export type OpenHouseViewType = "map_popup" | "list_impression" | "property_schedule_impression";
export type OpenHouseViewSurface = "home_open_houses" | "open_houses_page" | "property_detail";

/** One logical exposure: persistence completes before the client analytics event is sent. */
export function recordOpenHouseView(params: {
  orgIdentifier?: string;
  openHouseId: string;
  listingId: string;
  surface: OpenHouseViewSurface;
  viewType: OpenHouseViewType;
  basePath: string;
}) {
  if (!params.orgIdentifier) return;
  try {
    const eventId = crypto.randomUUID();
    void fetch(`${params.basePath}/api/events/open-house-view`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      keepalive: true,
      body: JSON.stringify({ openHouseId: params.openHouseId, eventId, surface: params.surface, viewType: params.viewType }),
    }).then(async (response) => {
      if (!response.ok || !process.env.NEXT_PUBLIC_POSTHOG_KEY) return;
      const persisted = await response.json();
      posthog.capture(OPEN_HOUSE_VIEW_EVENT, {
        app: "agentdirectory",
        org_id: persisted.orgId,
        open_house_id: persisted.openHouseId,
        listing_id: persisted.listingId,
        open_house_start_at: persisted.openHouseStartAt,
        open_house_end_at: persisted.openHouseEndAt,
        surface: params.surface,
        view_type: params.viewType,
        event_id: eventId,
        $insert_id: eventId,
      });
    }).catch(() => {});
  } catch {
    // Reporting cannot interrupt opening a popup or reading the schedule.
  }
}
